export function Welcome({
  suggestions,
  onPick,
}: {
  suggestions: string[];
  onPick: (s: string) => void;
}) {
  return (
    <section className="px-1 pt-6">
      <h2 className="font-serif text-3xl leading-snug text-purple dark:text-cream">
        ¿Qué quieres saber?
      </h2>
      <p className="mt-2 text-lg text-ink-soft dark:text-cream/80">
        Horarios, recorridos y por dónde pasa cada cofradía, con los datos oficiales del
        Ayuntamiento de Sevilla.
      </p>
      <ul className="mt-6 space-y-3" aria-label="Preguntas sugeridas">
        {suggestions.map((s) => (
          <li key={s}>
            <button
              type="button"
              onClick={() => onPick(s)}
              className="w-full rounded-2xl border-2 border-purple/25 bg-white/70 px-4 py-3 text-left text-lg leading-snug text-ink hover:border-purple focus-visible:outline-2 focus-visible:outline-purple dark:border-cream/20 dark:bg-night-800 dark:text-cream dark:hover:border-gold-300"
            >
              {s}
            </button>
          </li>
        ))}
      </ul>
      <a
        href="/reto/nuevo"
        className="mt-6 flex items-center justify-between gap-3 rounded-2xl border-2 border-gold/40 bg-gold-300/20 px-4 py-3 text-lg text-ink hover:border-gold focus-visible:outline-2 focus-visible:outline-gold dark:border-gold-300/30 dark:bg-gold-300/10 dark:text-cream"
      >
        <span>
          <strong className="block font-serif text-xl">Reto cofrade</strong>
          ¿Cuánto saben tus amigos? Rétalos por WhatsApp.
        </span>
        <span aria-hidden>→</span>
      </a>
    </section>
  );
}
